import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Page } from "../components/Page";
import { projectDefinitions } from "./projectDefinitions";
import { ProjectItem } from "./ProjectItem";

export function ProjectList() {
  const theme = useTheme();

  return (
    <Page title="Projects">
      <Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        <Typography
          sx={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "0.75rem",
            color: theme.palette.accent,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            marginBottom: "0.75rem"
          }}
        >
          // Standalone Apps
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fill, minmax(min(100%, 280px), 1fr))",
            gap: "1rem"
          }}
        >
          {projectDefinitions.map((project) => (
            <ProjectItem key={project.name} project={project} />
          ))}
        </Box>
      </Box>
    </Page>
  );
}
